import AccountProfile from "../../components/screen/profile/AccountProfile";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";

const AccountProfilePage = () => {
  return (
    <div className="">
      <PageTemplate
        header=""
        mainComponent={
          <div className="mt-24 lg:mt-0">
            <AccountProfile />
          </div>
        }
        pageRole={0}
      />
    </div>
  );
};

export default AccountProfilePage;
